<template>
  <div>
    <b-card class="bg-white rounded-xl">
      <div class="flex  justify-between  items-center">
        <div>
          <h2 class="text-2xl font-semibold">
            Welcome back, <span class="text-primary font-bold">Admin</span>
          </h2>

          <small class=" text-muted "
            >Check your community performance here.
          </small>
        </div>
        <!-- <div>
          <base-button outline type="primary" class="flex">
            <feather-icon icon="PlusIcon" class="mr-1"></feather-icon>Manage
            Accounts
          </base-button>
        </div> -->
      </div>

      <div class="lg:grid md:grid md:grid-cols-2 lg:grid-cols-3  gap-8 mt-12">
        <b-card
          class=" rounded-2xl  cust-shadow"
          v-for="(item, index) in steps"
          :key="'item -' + index"
        >
          <div>
            <div class="mb-4 flex justify-center">
              <div
                class="rounded-full width-height-90  flex justify-center items-center bg-f4f5f6"
              >
                <p class="font-bold text-primary text-3xl">{{ item.count }}</p>
              </div>
            </div>
            <div class=" pt-2 text-center">
              <p
                class="md:mb-3 lg:mb-3 mb-1 font-bold theme-color-tx md:text-lg lg:text-lg text-lg"
              >
                {{ item.title }}
              </p>
              <small class=" text-muted font-normal">
                {{ item.description }}
              </small>
            </div>
          </div>
        </b-card>
      </div>
    </b-card>
  </div>
</template>
<script>
import "../../scss/Index.scss";

export default {
  data() {
    return {
      steps: [
        {
          title: "Total users",
          count: "50",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
        },
        {
          title: "Total posts",
          count: "20",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
        },
        {
          title: "Posts in this month",
          count: "10",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
        },
        {
          title: "New users in this month",
          count: "40",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
        },
        {
          title: "Avg view on post",
          count: "10k",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
        },
        // {
        //   icon: "ActivityIcon",
        //   title: "View Statistics",
        //   description: "Sign-up with your Basic Details and Mobile Number."
        // },
        {
          title: "Post in Community 1",
          count: "10",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
        },
        {
          title: "Post in Community 2",
          count: "8",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
        },
        {
          title: "Post in Community 3",
          count: "15",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
        },
        {
          title: "Post in Community 4",
          count: "18",
          description:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
        }
      ]
    };
  }
};
</script>
